import anonymousImage from "../assets/images/boardOfDirectors/anonymousPerson.png";

const CSSManagment = [
  {
    image: anonymousImage,
    header: "Mohamed Abou Abdo",
    paragraph: "CIO - Chief information officer",
  },
  {
    image: anonymousImage,
    header: "Ahmed Abou Hussein",
    paragraph: "Chairman",
  },
  {
    image: anonymousImage,
    header: "Tarek Abaza",
    paragraph: "Managing Director",
  },
  {
    image: anonymousImage,
    header: "Rivan Ali",
    paragraph: "HR Business Partner- Board Member",
  },

  {
    image: anonymousImage,
    header: "Tamer Ismael",
    paragraph: "Deputy Managing Director",
  },
  {
    image: anonymousImage,
    header: "Adham Gamal El Din",
    paragraph: "Head of Technical",
  },
];

export default CSSManagment;
